import {
   ButtonVariant,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalMaxHeight,
   ModalWidth,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';
import { commonTranslationKeys } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { GroupSessionsCreateFormLoader } from './GroupSessionsCreateForm.loader';
import { GroupSessionsCreateForm } from './GroupSessionsCreateForm';
import { TherapeuticGroupCreateActionEventInterceptor } from './interceptors/TherapeuticGroupCreateActionEventInterceptor';
import { formInitializer } from './GroupSessionsCreateModal.utils';

type GroupSessionsCreateModalProps = {
   readonly onClose: VoidFunction;
};

export const GroupSessionsCreateModal = (props: GroupSessionsCreateModalProps): JSX.Element => {
   return (
      <Modal
         testId={'groupSessionsCreate'}
         title={translationKeys.createTherapeuticGroup}
         width={ModalWidth.WIDE}
         height={ModalMaxHeight.TALL}
      >
         <GroupSessionsCreateFormLoader>
            {({ practitioners }) => (
               <GroupSessionsCreateForm initializer={formInitializer} practitioners={practitioners}>
                  {({ handleSubmit, formState, trigger, reset }) => {
                     return (
                        <>
                           <ValidateFormEventInterceptor trigger={trigger}>
                              <TherapeuticGroupCreateActionEventInterceptor handleSubmit={handleSubmit}>
                                 <ModalConfirmButton
                                    testId={'saveAndAddAnotherTherapeuticGroup'}
                                    onClick={reset}
                                    label={translationKeys.saveAndAddAnother}
                                    variant={ButtonVariant.SECONDARY}
                                 />
                              </TherapeuticGroupCreateActionEventInterceptor>
                           </ValidateFormEventInterceptor>

                           <ValidateFormEventInterceptor trigger={trigger}>
                              <TherapeuticGroupCreateActionEventInterceptor handleSubmit={handleSubmit}>
                                 <ModalConfirmButton
                                    testId={'createTherapeuticGroup'}
                                    onClick={props.onClose}
                                    label={commonTranslationKeys.save}
                                 />
                              </TherapeuticGroupCreateActionEventInterceptor>
                           </ValidateFormEventInterceptor>

                           <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                           <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                        </>
                     );
                  }}
               </GroupSessionsCreateForm>
            )}
         </GroupSessionsCreateFormLoader>
      </Modal>
   );
};
